import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";

import * as statuses from "../../constants/databaseStatuses";

import FramePanel from "../global/FramePanel";
import AddDatabasePanel from "../../containers/scenes/incompatible/AddDatabasePanel";
import UpdateDatabasesPanel from "../../containers/scenes/incompatible/UpdateDatabasesPanel";
import InvalidDatabasesPanel from "../../containers/scenes/incompatible/InvalidDatabasesPanel";
import SimpleFooter from "../../containers/global/SimpleFooter";
import NotificationPanel from "../../containers/apps/default/NotificationPanel";

export default class Incompatible extends Component {
    handleDisconnectClick = () => {
        this.props.serverDisconnect();
    };

    getIncompatibleBody = () => {
        if (this.props.updateDatabaseList.length > 0) {
            return (
                <div className="select-server-window" style={{WebkitAppRegion: "no-drag"}}>
                    <div className="col-xs-12 redlike-blue redlike-logo">
                        <div className="redlike-logo-all" />
                    </div>
                    <UpdateDatabasesPanel />
                </div>
            );
        }

        if (this.props.invalidDatabaseList.length > 0) {
            return (
                <div className="select-server-window" style={{WebkitAppRegion: "no-drag"}}>
                    <div className="col-xs-12 redlike-blue redlike-logo">
                        <div className="redlike-logo-all" />
                    </div>
                    <InvalidDatabasesPanel />
                </div>
            );
        }

        return (
            <div className="select-server-window" style={{WebkitAppRegion: "no-drag"}}>
                <div className="col-xs-12 redlike-blue redlike-logo">
                    <div className="redlike-logo-all" />
                </div>
                <AddDatabasePanel />
            </div>
        );
    };

    getInvalidDatabaseMessage = () => {
        if (this.props.updateDatabaseList.length > 0) {
            if (this.props.loading) {
                if (this.props.updateDatabaseList.length > 1) {
                    return translate("welcome.updatingDatabases") + "...";
                }

                return translate("welcome.updatingDatabase") + "...";
            }

            if (this.props.updateDatabaseList.length > 1) {
                return translate("welcome.databasesCompatibility");
            }

            return translate("welcome.databaseCompatibility");
        }

        if (this.props.invalidDatabaseList.length === 0) {
            return translate("welcome.availableDatabase");
        }

        switch (this.props.invalidDatabaseList[0].status) {
            case statuses.MAIN_AND_LOCAL_MISSING:
                return translate("welcome.availableDatabaseMainAndLocalMissing");
            case statuses.MAIN_MISSING:
                return translate("welcome.availableDatabaseMainMissing");
            case statuses.LOCAL_MISSING:
                return translate("welcome.availableDatabaseLocalMissing");
            case statuses.MAIN_AND_LOCAL_ERROR:
                return translate("welcome.availableDatabaseMainAndLocalError");
            case statuses.MAIN_ERROR:
                return translate("welcome.availableDatabaseMainError");
            case statuses.LOCAL_ERROR:
                return translate("welcome.availableDatabaseLocalError");
            default:
                return translate("welcome.availableDatabase");
        }
    };

    getInfo = () => {
        if (!this.props.availableDatabase) {
            return <span>{this.getInvalidDatabaseMessage()}</span>;
        }

        if (!this.props.compatibleServer) {
            return <span>{translate("welcome.compatibility", [this.props.serverVersion])}</span>;
        }

        return <span>{translate("welcome.compatibilityDatabase")}</span>;
    };

    render() {
        return (
            <div style={{WebkitAppRegion: "drag"}}>
                <FramePanel />
                <div className="welcome">
                    {this.getIncompatibleBody()}
                    <div className="connection-info" style={{WebkitAppRegion: "no-drag"}}>
                        {this.getInfo()}
                        <button
                            className="btn btn-primary btn-xs"
                            onClick={this.handleDisconnectClick}
                            style={{marginLeft: "15px"}}
                        >
                            <Translate value="general.disconnect" />
                        </button>
                    </div>
                    <NotificationPanel />
                    <SimpleFooter virtualKeyboardSupport={false} />
                </div>
            </div>
        );
    }
}
